import find from 'lodash/find';
import isArray from 'lodash/isArray';
import keys from 'lodash/keys';

export function findChoice(choices, filter, { pluck } = {}) {
    const filterField = keys(filter)[0];
    let fields, isPassedArray;
    if (isArray(filter[filterField])) {
        fields = filter[filterField];
        isPassedArray = true;
    } else {
        fields = [filter[filterField]];
        isPassedArray = false;
    }

    const values = fields.map(field => {
        const choice = find(choices, { [filterField]: field });
        if (!choice) {
            throw new Error(`Choice ${field} does not exist in choices`);
        }

        if (pluck) {
            return choice[pluck];
        }

        return choice;
    });

    if (isPassedArray) {
        return values;
    } else {
        return values[0];
    }
}
